<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img4.jpg"/></p>
<p class="chap"><a id="ch1"></a>COLUMBUS DID NOT DISCOVER AMERICA, 1492</p>
<p class="noindent"><span class="big">C</span>olumbus Day is the annual celebration in the United States of that fateful dawn in October 1492 when Italian explorer Christopher Columbus, in service to the Spanish crown, made landfall in the Bahamas. Columbus, however, was late in the European discovery of the Western Hemisphere.</p>
<p class="indent">The second group to settle parts of America was Norsemen from Scandinavia. In several attempts around the year 1000 CE, the Vikings tried to settle the flat, wooded country they called Vineland, but the Norse were not colonizers. They lacked capital and infrastructure for permanent settlements, and soon cold, wolves, and hostile natives caused them to abandon their attempts after about a dozen years.</p>
<p class="indent">The real Eurasian discoverers of America were Stone Age hunter-gatherers sometime between 60,000 and 15,000 BCE, who crossed what was then the narrow treeless Bering Land Bridge between present-day Russia and Alaska. It took probably another one thousand years for these explorers and their descendants to work their way south and east to become the original inhabitants or discoverers of North and South America. <span class="color">(19-011, 19-012)</span></p>
<p class="image"><img alt="image" src="images/img5.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?5c020c58